import React from 'react'

export default function InlineError(props){
    return(
        <p className="error">{props.message}</p>
    )
}